import { atom } from "recoil";
import { PhoneAlertLog } from "../model";

export const lastPhoneAlertLogState = atom<PhoneAlertLog | undefined>({
  key: "lastPhoneAlertLogState",
  default: undefined
})